import { useMutation, useQueryClient } from "@tanstack/react-query";
import { deleteCreditTier } from "@/api/creditTiers";
import { CreditTiersQueryKeys } from "@/tanstackQuery/queries/creditTiers";

export interface DeleteCreditTierOptions {
  onSuccess?: () => void;
  onError?: (error: any) => void;
}

export const useDeleteCreditTier = (options?: DeleteCreditTierOptions) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: deleteCreditTier,
    onSuccess() {
      queryClient.invalidateQueries({
        queryKey: [CreditTiersQueryKeys.All],
      });
      options?.onSuccess?.();
    },
    onError: options?.onError,
  });
};
